import React, { useState } from 'react';
import { Collapse } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
const VipStockInfo = ({ stockInfo }) => {
  const [visible, setVisible] = useState(false);

  if (!stockInfo || !stockInfo.length) return null;

  return (
    <Collapse in={visible} collapsedHeight={30}>
      <IconButton
        aria-label="expand row"
        size="small"
        onClick={() => setVisible(prev => !prev)}
      >
        {visible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
      <div>
        {stockInfo.map(item => {
          return (
            <div key={item.code}>
              {item.code} - {item.codeName}
            </div>
          );
        })}
      </div>
    </Collapse>
  );
};

export default VipStockInfo;
